var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSapphireRank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 208,
    viewBox: "0 0 182 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1261162906",
    filter: "url(#filter0_d_3654_2582)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5808 0L177.215 49.9732V149.973L90.5808 200L4 149.973V49.9732L90.5808 0Z",
    fill: "#FF9700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5823 12.6113L166.32 56.3043V143.69L90.5823 187.383L14.8979 143.69V56.3043L90.5823 12.6113Z",
    fill: "#0068FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0305 74.2324L62.0262 69.5088L78.505 59.9543L90.5823 48.5211V12.6113L52.7401 34.4578L14.8979 56.3043L46.0305 74.2324Z",
    fill: "url(#paint0_radial_3654_2582)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5801 48.5211L102.711 59.9543L119.19 69.5088L135.186 74.2324L166.318 56.3043L128.476 34.4578L90.5801 12.6113V48.5211Z",
    fill: "url(#paint1_radial_3654_2582)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.19 74.2367L131.325 90.5007V109.502L135.19 125.713L166.323 143.695V100.002V56.3086L135.19 74.2367Z",
    fill: "url(#paint2_radial_3654_2582)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.186 125.711L119.19 130.488L102.711 139.989L90.5801 151.476V187.386L128.476 165.539L166.318 143.693L135.186 125.711Z",
    fill: "url(#paint3_radial_3654_2582)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5823 151.476L78.505 139.989L62.0262 130.488L46.0305 125.711L14.8979 143.693L52.7401 165.539L90.5823 187.386V151.476Z",
    fill: "url(#paint4_radial_3654_2582)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0305 125.713L49.8953 109.502V90.5007L46.0305 74.2367L14.8979 56.3086V100.002V143.695L46.0305 125.713Z",
    fill: "url(#paint5_radial_3654_2582)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.087 96.6736C138.087 88.8905 165.57 62.052 166.321 83.147V56.3086L142.596 69.9962L138.087 88.8904V96.6736Z",
    fill: "url(#paint6_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1433 36.5018C55.6382 36.5018 61.0059 55.9328 59.8787 62.8572L76.3575 53.3027C72.278 49.2232 69.7016 24.5856 81.7252 17.8223L49.5191 36.5018H49.1433Z",
    fill: "url(#paint7_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.368 149.976C145.33 149.278 139.265 148.258 129.925 133.873L123.967 135.698L111.621 142.783C118.063 147.185 130.247 160.014 126.543 166.723L155.368 150.083V149.976Z",
    fill: "url(#paint8_radial_3654_2582)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.752 53.2988L123.968 64.4099L138.085 88.8866V111.055L123.968 135.532L104.752 146.643H76.464L57.2476 135.532L43.1306 111.055V88.8866L57.2476 64.4099L76.464 53.2988H104.752Z",
    fill: "url(#paint9_radial_3654_2582)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4639 53.3021L90.5809 39.9902L104.752 53.3021H76.4639Z",
    fill: "url(#paint10_radial_3654_2582)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.971 64.4121L142.597 69.9945L138.088 88.8888L123.971 64.4121Z",
    fill: "url(#paint11_radial_3654_2582)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.088 111.061L142.597 130.008L123.971 135.537L138.088 111.061Z",
    fill: "url(#paint12_radial_3654_2582)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4639 146.646L90.5809 160.012L104.752 146.646H76.4639Z",
    fill: "url(#paint13_radial_3654_2582)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1314 111.061L38.6226 130.008L57.2484 135.537L43.1314 111.061Z",
    fill: "url(#paint14_radial_3654_2582)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2484 64.4121L38.6226 69.9945L43.1314 88.8888L57.2484 64.4121Z",
    fill: "url(#paint15_radial_3654_2582)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.216 123.351L90.581 100.002L50.216 76.6523L43.1306 88.8907V111.059L50.216 123.351Z",
    fill: "url(#paint16_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.2175 76.6483L90.5825 99.9977V53.2988H76.4655L57.2492 64.4099L50.2175 76.6483Z",
    fill: "url(#paint17_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5801 53.2988V99.9977L130.999 76.6483L123.967 64.4099L104.751 53.2988H90.5801Z",
    fill: "url(#paint18_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.999 76.6523L90.5801 100.002L130.999 123.351L138.084 111.059V88.8907L130.999 76.6523Z",
    fill: "url(#paint19_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.999 123.349L90.5801 100V146.645H104.751L123.967 135.534L130.999 123.349Z",
    fill: "url(#paint20_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5825 146.645V100L50.2175 123.349L57.2492 135.534L76.4655 146.645H90.5825Z",
    fill: "url(#paint21_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8555 141.33L76.4636 147.771C80.7603 151.758 84.6282 156.184 88.0041 160.976C89.6503 168.399 90.5316 175.971 90.6343 183.574C90.6733 175.94 91.5008 168.332 93.1034 160.868C93.4159 160.023 93.8499 159.227 94.3917 158.507L99.4373 151.904L94.0696 155.34C93.1543 155.903 92.0789 156.148 91.0101 156.038C86.9954 154.619 83.5988 151.848 81.4019 148.201L87.7895 146.698L77.9666 145.946L66.8555 141.33Z",
    fill: "url(#paint22_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8555 58.8854L76.4636 52.4442C80.7296 48.4665 84.595 44.0798 88.0041 39.3471C89.6406 31.4509 90.5213 23.4167 90.6343 15.3535C90.6801 23.4124 91.507 31.4478 93.1034 39.3471C93.4035 40.2148 93.8382 41.03 94.3917 41.7625L99.4373 48.3648L94.0696 44.9295C93.1765 44.3142 92.0816 44.0644 91.0101 44.2317C88.9701 44.8382 87.0707 45.8431 85.4215 47.1882C83.7723 48.5334 82.4061 50.1921 81.4019 52.0685L88.0578 53.3567L78.235 54.1619L67.1238 58.9391L66.8555 58.8854Z",
    fill: "url(#paint23_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8591 58.8845L56.4995 64.2522C50.8964 65.9309 45.1441 67.0634 39.3229 67.6339C32.0525 65.3353 25.0377 62.2956 18.3889 58.5625C24.9487 62.2863 31.1325 66.6365 36.8538 71.5523C38.7124 74.7416 40.2583 78.1031 41.47 81.5899C41.47 79.0134 40.7185 74.0214 42.2214 71.9817C45.399 69.1387 49.5548 67.638 53.8156 67.7949L51.6149 74.1825L56.9826 66.0772L66.6444 58.8845H66.8591Z",
    fill: "url(#paint24_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.085 100L138.891 111.541C140.146 117.228 141.944 122.782 144.258 128.127C149.381 132.995 155.055 137.246 161.167 140.794C155.007 137.332 148.492 134.543 141.735 132.474C140.828 132.339 139.905 132.339 138.998 132.474L130.785 133.548L136.636 130.327C137.577 129.845 138.318 129.047 138.73 128.073C139.53 123.887 138.827 119.553 136.744 115.835L132.288 120.934L136.529 112.077L137.924 100.054L138.085 100Z",
    fill: "url(#paint25_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0123 139.451C57.249 135.586 20.2656 145.946 38.14 157.111L14.8979 143.692L38.6231 130.004L57.249 135.372L64.0123 139.236V139.451Z",
    fill: "url(#paint26_radial_3654_2582)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7633 53.8916L90.5808 7.83682V0L4 49.9732L10.7633 53.8916Z",
    fill: "url(#paint27_radial_3654_2582)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5801 7.83682L170.451 53.8916L177.215 49.9732L90.5801 0V7.83682Z",
    fill: "url(#paint28_radial_3654_2582)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5075 19.5912L90.5848 12.6132V7.83594L10.7673 53.8907L14.9005 56.3061L46.0867 38.2707L78.5075 19.5912Z",
    fill: "url(#paint29_radial_3654_2582)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5801 12.6132L128.476 34.4597L166.318 56.3061L170.451 53.8907L90.5801 7.83594V12.6132Z",
    fill: "url(#paint30_radial_3654_2582)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7633 146.058V53.895L4 49.9766V149.977L10.7633 146.058Z",
    fill: "url(#paint31_radial_3654_2582)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7673 53.8926V146.056L14.9005 143.694V100.001V56.308L10.7673 53.8926Z",
    fill: "url(#paint32_radial_3654_2582)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.32 83.1465V100.001V143.694L170.453 146.056V53.8926L166.32 56.308V83.1465Z",
    fill: "url(#paint33_radial_3654_2582)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.456 53.895V146.058L177.219 149.977V49.9766L170.456 53.895Z",
    fill: "url(#paint34_radial_3654_2582)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7426 165.542L38.1425 157.115L14.9005 143.695L10.7673 146.057L90.5848 192.166V187.388L52.7426 165.542Z",
    fill: "url(#paint35_radial_3654_2582)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5808 192.163L10.7633 146.055L4 149.973L90.5808 200V192.163Z",
    fill: "url(#paint36_radial_3654_2582)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.997 175.043L90.5801 187.388V192.166L170.451 146.057L166.318 143.695L144.418 156.309L128.476 165.542L111.997 175.043Z",
    fill: "url(#paint37_radial_3654_2582)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.451 146.055L90.5801 192.163V200L177.215 149.973L170.451 146.055Z",
    fill: "url(#paint38_radial_3654_2582)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6345 0V7.83682L10.8706 53.8916L4 50.0805C12.964 50.0805 21.0692 46.6452 40.4466 35.1047L59.3945 24.3693C79.0939 13.6339 86.233 8.26623 90.6345 0.322058V0Z",
    fill: "url(#paint39_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.537 143.695L170.67 146.057L90.6379 192.166V187.549C94.5027 189.213 100.729 184.49 120.268 173.271L139.215 162.536C158.754 151.264 165.356 148.043 166.322 143.91L166.537 143.695Z",
    fill: "url(#paint40_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4939 29.2544L89.7258 7.24692L90.5846 0.859375L91.4971 7.24692L102.555 14.708L90.5846 8.96458L53.4939 29.2544Z",
    fill: "url(#paint41_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.274 173.268L170.456 147.127L176.467 149.543L171.368 145.571L170.456 121.738L169.436 145.517L123.274 173.268Z",
    fill: "url(#paint42_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9111 32.4727L10.7667 52.8162L4.75488 50.4007L9.85418 54.4265L10.7667 107.083L11.7865 54.4802L47.9111 32.4727Z",
    fill: "url(#paint43_radial_3654_2582)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9111 167.524L10.7667 147.127L4.75488 149.542L9.85418 145.57L10.7667 117.443L11.7865 145.516L47.9111 167.524Z",
    fill: "url(#paint44_radial_3654_2582)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3654_2582",
    x: 0,
    y: 0,
    width: 181.219,
    height: 208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3654_2582"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3654_2582",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.9801 49.2189) scale(120.558 120.558)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(138.514 73.5882) scale(111.702 111.702)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.638 62.9645) scale(92.1632 92.1632)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.329 78.7974) scale(165.7 165.7)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.7949 161.835) scale(113.419 113.419)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.8233 57.1674) scale(100.859 100.859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.687 112.455) scale(58.4004 58.4004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D4E0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#B2C8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#87A9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5282C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.3773 57.9726) scale(121.149 121.149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.967 127.271) scale(50.7246 50.7246)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.2036 55.5533) scale(121.202 121.202)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0049FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.1219 19.8614) scale(73.8057 73.8057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.781 36.8222) scale(59.796)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.812 128.989) scale(73.2153 73.2152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(99.4376 134.301) scale(70.8535 70.8534)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2795FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.877 133.927) scale(81.6425 81.6425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.3896 65.3783) scale(108.749 108.749)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-63.74 125.015) scale(155.824 155.824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.0544 -32.3158) scale(146.162 146.162)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.372 22.3809) scale(92.4316 92.4316)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(162.99 42.8896) scale(104.348 104.348)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(145.384 185.883) scale(155.878 155.878)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.0603 171.82) scale(101.932 101.932)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.8093 151.314) scale(57.7563 57.7563)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.3681 38.6493) scale(52.1202 52.1202)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.5494 61.3) scale(49.5437 49.5437)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.346 129.576) scale(63.4997 63.4997)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.891 193.235) scale(75.8454 75.8454)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D4E0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#B2C8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#87A9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5282C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(89.9366 -2.41546) scale(106.28 106.28)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(139.694 -34.7289) scale(127.966 127.966)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.1495 50.6701) scale(87.6543 87.6543)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.812 -17.6069) scale(192.646 192.646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-93.2088 85.5106) scale(152.442 152.442)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.011 98.337) scale(129.683 129.683)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.381 102.9) scale(136.769 136.769)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.533 83.6856) scale(142.512 142.512)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.0201 116.857) scale(117.66 117.66)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.0359 114.815) scale(144.605 144.605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165.03 176.224) scale(102.469 102.469)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.2441 105.421) scale(118.304 118.304)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.0929 -4.50885) scale(80.4616 80.4616)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD58C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.397 142.514) scale(67.5792 67.5792)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD58C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.9485 1.55718) scale(59.3666 59.3666)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(174.428 148.362) scale(96.9941 96.9941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.43872 40.7926) scale(64.0365 64.0365)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_3654_2582",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.0667 143.047) scale(58.4004 58.4004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSapphireRank);
export default __webpack_public_path__ + "static/media/sapphireRank.0c98b820b5cb603b8a96351d51c5b3be.svg";
export { ForwardRef as ReactComponent };